import React, { useState, useEffect, useRef } from "react";
import styles from "./index.module.scss";
import Link from "next/link";
import { useRouter } from "next/router";
import useWindowWidth from "hooks/useWindowWidth";

export default function Filter(props) {
  const { query } = useRouter();
  const width = useWindowWidth();
  const { categories = [], onChange, onInputFieldHandler } = props;
  const [activeIndex, setActiveIndex] = useState(null);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const searchRef = useRef(null);

  const onClickHandler = (category) => {
    if (activeIndex === category.identifier) {
      return false;
    }
    setActiveIndex(category.identifier);
    onChange(category);
  };

  const toggleSearch = () => {
    setIsSearchActive(!isSearchActive);
    if (width < 1022) {
      setIsSearchActive(!isSearchActive);
    }
  };

  const handleInputChange = (e) => {
    onInputFieldHandler(e.target.value);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsSearchActive(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchRef]);

  useEffect(() => {
    setActiveIndex(query.slug || null);
  }, [query.slug]);

  return (
    <div className={styles.container} ref={searchRef}>
      <div
        className={`${styles.items} ${isSearchActive ? styles.slideUp : ""}`}
      >
        {width < 1022 && (
          <div className={styles.search} onClick={toggleSearch}>
            <img
              src="/svgs/icons/search.svg"
              width="24"
              height="24"
              alt="search"
            />
          </div>
        )}
        <Link scroll={false} href={"/blog"}>
          <div
            onClick={() => {
              setActiveIndex(null);
              onChange({});
            }}
            className={`${styles.item} ${styles.item_first} ${
              activeIndex === null ? styles.active : ""
            }`}
          >
            <span>All</span>
          </div>
        </Link>
        {categories.map((category, index) => (
          <Link
            scroll={false}
            href={`/blog/categories/${category.identifier}`}
            key={index}
          >
            <div
              onClick={() => onClickHandler(category)}
              className={`${styles.item} ${
                activeIndex === category.identifier ? styles.active : ""
              }`}
            >
              <span>{category.title}</span>
            </div>
          </Link>
        ))}
        {width > 1022 && (
          <div className={styles.search} onClick={toggleSearch}>
            <img
              src="/svgs/icons/search.svg"
              width="24"
              height="24"
              alt="search"
            />
          </div>
        )}
      </div>
      <div
        className={`${styles.searchInputContainer} ${
          isSearchActive ? styles.expand : ""
        }`}
      >
        <input
          onChange={handleInputChange}
          type="text"
          autoFocus={isSearchActive}
        />
      </div>
    </div>
  );
}
